<template>
  <div class="t-faq">
    <div class="t-lk-container">
      <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>

      <h1 class="t-lk-title _question t-lk-container-mobile">{{ question.name }}</h1>

      <div class="t-faq__container">
        <div class="t-faq__left">
          <div v-animation:bottom.delay class="t-faq__item">
            <div v-if="question.descriptionTop" class="t-faq__html t-html _lk" v-html="question.descriptionTop"></div>

            <template v-for="item in question.constructor">
              <div v-if="item.type === 'builder_gallery' && item.content.gallery.length > 0" class="t-faq-slider">
                <swiper :options="questionSlider">
                  <swiper-slide
                    v-for="(slide, index2) in item.content.gallery"
                    :key="'questionSlider' + index2"
                    class="t-faq-slider__item"
                  >
                    <img :src="slide" alt="img" class="t-faq-slider__img" />
                  </swiper-slide>
                </swiper>
                <div class="t-swiper-nav t-faq-slider__nav">
                  <div class="swiper-button-prev t-swiper-nav__prev js-question-slider-prev" slot="button-prev">
                    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 1L1 11L11 21" stroke="#9FA2AC" stroke-width="2" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div class="swiper-button-next t-swiper-nav__next js-question-slider-next" slot="button-next">
                    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L11 11L1 21" stroke="#9FA2AC" stroke-width="2" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>

              <h2 v-if="item.type === 'builder_header'" class="t-faq__title">{{ item.content.title }}</h2>

              <div v-if="item.type === 'builder_text'" class="t-faq__html t-html _lk _bottom" v-html="item.content.text"></div>

              <div v-if="item.type === 'faq_link' && item.content.links && item.content.links.length > 0" class="t-faq-links">
                <a
                  :href="link.link"
                  target="_blank"
                  class="t-faq-links__item"
                  v-for="(link, index2) in item.content.links"
                  :key="'links' + index2"
                >
                  <svg
                    class="t-faq-links__svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.0002 4.84016C13.5362 4.84016 13.1602 4.46408 13.1602 4.00016C13.1602 3.53624 13.5362 3.16016 14.0002 3.16016H20.0002C20.4641 3.16016 20.8402 3.53624 20.8402 4.00016V10.0002C20.8402 10.4641 20.4641 10.8402 20.0002 10.8402C19.5362 10.8402 19.1602 10.4641 19.1602 10.0002V6.0281L10.5941 14.5941C10.2661 14.9222 9.73423 14.9222 9.40619 14.5941C9.07815 14.2661 9.07815 13.7342 9.40619 13.4062L17.9722 4.84016H14.0002ZM3.99197 5.99197C4.52458 5.45937 5.24694 5.16016 6.00016 5.16016H10.0002C10.4641 5.16016 10.8402 5.53624 10.8402 6.00016C10.8402 6.46408 10.4641 6.84016 10.0002 6.84016H6.00016C5.6925 6.84016 5.39745 6.96237 5.17991 7.17991C4.96237 7.39745 4.84016 7.6925 4.84016 8.00016V18.0002C4.84016 18.3078 4.96237 18.6029 5.17991 18.8204C5.39745 19.0379 5.69251 19.1602 6.00016 19.1602H16.0002C16.3078 19.1602 16.6029 19.0379 16.8204 18.8204C17.0379 18.6029 17.1602 18.3078 17.1602 18.0002V14.0002C17.1602 13.5362 17.5362 13.1602 18.0002 13.1602C18.4641 13.1602 18.8402 13.5362 18.8402 14.0002V18.0002C18.8402 18.7534 18.5409 19.4757 18.0083 20.0083C17.4757 20.5409 16.7534 20.8402 16.0002 20.8402H6.00016C5.24694 20.8402 4.52458 20.5409 3.99197 20.0083C3.45937 19.4757 3.16016 18.7534 3.16016 18.0002V8.00016C3.16016 7.24694 3.45937 6.52458 3.99197 5.99197Z"
                      fill="#C0C0CC"
                    />
                  </svg>
                  <span class="t-faq-links__name">{{ link.name }}</span>
                  <span class="t-faq-links__link">{{ $root.staticText.lk.faqLinks }}</span>
                </a>
              </div>

              <h2 v-if="item.type === 'builder_video' && item.content.title" class="t-faq__title">
                {{ item.content.title }}
              </h2>
              <lk-video-cmp v-if="item.type === 'builder_video' && item.content.src" :video="item.content.src"> </lk-video-cmp>
            </template>
          </div>
        </div>
        <div v-animation:bottom.delay class="t-faq__right">
          <banner-native-cmp v-if="banner" :banner="banner" :is-vertical="true"></banner-native-cmp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import lkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs.vue'
import lkVideo from '@components/lk/lk-video/lk-video.vue'
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import { router } from '@src/routes'

export default {
  name: 'lk-faq-category-question',
  data() {
    return {
      breadcrumbs: null,
      banner: null,
      question: '',

      questionSlider: {
        spaceBetween: 24,
        loop: true,
        cursor: 'grab',
        speed: 500,
        navigation: {
          nextEl: '.js-question-slider-next',
          prevEl: '.js-question-slider-prev',
        },
        breakpoints: {
          920: {
            spaceBetween: 8,
          },
        },
      },
    }
  },
  components: {
    'lk-breadcrumbs-cmp': lkBreadcrumbs,
    'lk-video-cmp': lkVideo,
    'banner-native-cmp': bannerNative,
  },
  methods: {
    setData(data) {
      this.breadcrumbs = data.breadcrumbs
      this.question = data.question
      this.banner = data.banner
    },
  },
  beforeRouteEnter(to, from, next) {
    let url =
      process.env.NODE_ENV !== 'production' ? 'lk/faqCategoryQuestion.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/faq/category/question/index.vue